export const categoriesDict = [
    { name: "ALL", description: "Todos" },
    { name: "EV_STATION", description: "Estaciones de carga/Cargadores" },
    { name: "ACCESSORY", description: "Accesorios/Repuestos"},
    { name: "SERVICE", description: "Servicios"},
  ];